/***
 * Created on 2023/7/24
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React from 'react';
import ModalDialog from "../../common/modal_dialog/modalDialog";
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {apiDelete} from "../../../service/api";
import {useTranslation} from "react-i18next";


function RemoveUserAppDialog(props) {
    const {meta, ..._props} = props;
    const queryClient = useQueryClient();
    const { t } = useTranslation();

    const removeAppMutation = useMutation({
        mutationFn: async () => await apiDelete(`/ajax/user/app/${meta.app_id}`),
        onSuccess: () => {
            console.log('done')
            queryClient.invalidateQueries({
                queryKey: ['userApplications']
            })
        },
        onError: (error, variables, context) => {
            console.error(error);
        }
    })

    const onSubmit = async () => {
        console.log(meta);
        await removeAppMutation.mutateAsync();
    }

    return (
        <ModalDialog {..._props} submitText={t('@Confirm@')} submitAction={onSubmit}>
            <div className="dialog-content">
                <p>
                    {t('@Notice: Once the application is removed, you have to re-link the application with myQNAPcloud account again if you want to use myQNAPcloud account to sign in this application.@')}
                </p>
            </div>

        </ModalDialog>
    );
}

export default RemoveUserAppDialog;